export default __webpack_public_path__ + "static/media/tools_dark.c7409c48.png";